/**
 *
 * @module serviceConfiguration
 *
 */

/**
 *
 * @class ServiceConfiguration
 * @desc Provides base ServiceConfiguration
 *
 */
export default class ServiceConfiguration {

    /**
     *
     * @param {ServiceClientConfiguration} client
     * @param {Object} extras
     * @param {Boolean} [disabled=false]
     *
     */
    constructor(client, extras, disabled = false) {

        /**
         *
         * @access public
         * @type {ServiceClientConfiguration}
         *
         */
        this.client = client;

        /**
         *
         * @access public
         * @type {Object}
         *
         */
        this.extras = extras;

        /**
         *
         * @access public
         * @type {Boolean}
         *
         */
        this.disabled = disabled;

    }

}



// WEBPACK FOOTER //
// ./src/services/configuration/serviceConfiguration.js